import { useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { signinRedirect } = useAuth();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    document.title = "Login | Kloudscan";
  }, []);

  // 🔥 Prevent Safari / S3 / CloudFront / Chrome BFCache behavior
  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.onpageshow = (evt) => {
      if (evt.persisted) {
        window.location.reload();
      }
    };
  }, []);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const intent = localStorage.getItem("login_intent");

    if (intent === "from_header") {
      localStorage.removeItem("login_intent");

      // Clear stale auth state before login to ensure clean OIDC flow
      localStorage.removeItem("authState");
      localStorage.removeItem("logoutInitiator");

      // Clear all OIDC keys for a fresh start
      for (const key of Object.keys(localStorage)) {
        if (key.startsWith("oidc.")) {
          localStorage.removeItem(key);
        }
      }

      // Clear session flags
      sessionStorage.removeItem("logoutInProgress");

      signinRedirect();
      return;
    }

    navigate("/", { replace: true });
  }, [navigate, signinRedirect]);

  return (
    <Backdrop open sx={{ color: "#fff", zIndex: 9999 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Login;
